


















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Closure from "../../store/entities/booking/closure";
import IntTimePicker from '../../components/int-time-picker.vue';
import Ajax from '../../lib/ajax';
import DateCheckbox from '../../components/date-checkbox.vue';

@Component({
    components: { IntTimePicker,DateCheckbox }
})
export default class CreateClosure extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    closure: Closure = new Closure();

    // 保存订单
    save() {
        (this.$refs.closureForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: "closure/update",
                    data: this.closure
                });
                (this.$refs.closureForm as any).resetFields();

                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.closureForm as any).resetFields();

        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.closure = Util.extend(
                true,
                this.closure,
                this.$store.state.closure.editClosure
            );
        }
    }
    async created(){
    }
    closureRule = {
        startDate: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, this.L("StartDate")),
                trigger: "change"
            }
        ],
        endDate: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, this.L("EndDate")),
                trigger: "change"
            }
        ],
        dateType: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, '日期类型'),
                trigger: "change"
            }
        ]
    };
}
